<template>
  <b-row class="cardStatus">
    <b-col cols="12" lg="4" class="mb-2">
      <StatisticCard
        text="Finalizados"
        color="success"
        :quantity="result.delivered.total"
        :loading="loading"
        :linkRota="'lojista-pedidos-app'"
        :statusPedido="'4'"
        class="cardPointer"
      >
        <div
          class="d-flex justify-content-between align-items-md-baseline align-items-sm-baseline align-items-xl-center align-items-lg-center flex-md-column flex-sm-column flex-lg-row flex-xl-row"
          slot-scope="{ quantity }"
        >
          <span class="font-weight-bold mr-2">{{ quantity }}</span>
          <div class="d-flex align-items-center justify-content-between">
            <i class="fas fa-money-check-alt mr-1 text-success"></i>
            <span class="font-weight-bold ml-auto">{{
              formatNumber(result.delivered.totalValue)
            }}</span>
          </div>
        </div>
      </StatisticCard>
    </b-col>
    <b-col cols="12" lg="4" class="mb-2">
      <StatisticCard
        text="Faltam entregar"
        color="primary"
        :linkRota="'lojista-pedidos-app'"
        :statusPedido="'2'"
        class="cardPointer"
        :loading="loading"
        :quantity="result.pendingToDelivery.total"
      >
        <div
          class="d-flex justify-content-between align-items-md-baseline align-items-sm-baseline align-items-xl-center align-items-lg-center flex-md-column flex-sm-column flex-lg-row flex-xl-row"
          slot-scope="{ quantity }"
        >
          <span class="font-weight-bold mr-2">{{ quantity }}</span>
          <div class="d-flex align-items-center justify-content-between">
            <i class="fas fa-money-check-alt mr-1 text-primary"></i>
            <span class="font-weight-bold ml-auto">{{
              formatNumber(result.pendingToDelivery.totalValue)
            }}</span>
          </div>
        </div>
      </StatisticCard>
    </b-col>
    <b-col cols="12" lg="4" class="mb-2">
      <StatisticCard
        text="Faltam pagar"
        color="warning"
        :linkRota="'lojista-pedidos-app'"
        :statusPedido="'1'"
        class="cardPointer"
        :loading="loading"
        :quantity="result.pendingToPay.total"
      >
        <div
          class="d-flex justify-content-between align-items-md-baseline align-items-sm-baseline align-items-xl-center align-items-lg-center flex-md-column flex-sm-column flex-lg-row flex-xl-row"
          slot-scope="{ quantity }"
        >
          <span class="font-weight-bold mr-2">{{ quantity }}</span>
          <div class="d-flex align-items-center justify-content-between">
            <i class="fas fa-money-check-alt mr-1 text-warning"></i>
            <span class="font-weight-bold ml-auto">{{
              formatNumber(result.pendingToPay.totalValue)
            }}</span>
          </div>
        </div>
      </StatisticCard>
    </b-col>
    <b-col cols="12" lg="6" class="mb-2">
      <StatisticCard
        text="Enviados"
        color="secondary"
        :linkRota="'lojista-pedidos-app'"
        :statusPedido="'3'"
        class="cardPointer"
        :loading="loading"
        :quantity="result.sent.total"
      >
        <div
          class="d-flex justify-content-between align-items-md-baseline align-items-sm-baseline align-items-xl-center align-items-lg-center flex-md-column flex-sm-column flex-lg-row flex-xl-row"
          slot-scope="{ quantity }"
        >
          <span class="font-weight-bold mr-2">{{ quantity }}</span>
          <div class="d-flex align-items-center justify-content-between">
            <i class="fas fa-money-check-alt mr-1 text-secondary"></i>
            <span class="font-weight-bold ml-auto">{{
              formatNumber(result.sent.totalValue)
            }}</span>
          </div>
        </div>
      </StatisticCard>
    </b-col>
    <b-col cols="12" lg="6">
      <StatisticCard
        text="Cancelados"
        color="danger"
        :linkRota="'lojista-pedidos-app'"
        :statusPedido="'6'"
        class="cardPointer"
        :loading="loading"
        :quantity="result.canceled.total"
      >
        <div
          class="d-flex justify-content-between align-items-md-baseline align-items-sm-baseline align-items-xl-center align-items-lg-center flex-md-column flex-sm-column flex-lg-row flex-xl-row"
          slot-scope="{ quantity }"
        >
          <span class="font-weight-bold mr-2">{{ quantity }}</span>
          <div class="d-flex align-items-center justify-content-between">
            <i class="fas fa-money-check-alt mr-1 text-danger"></i>
            <span class="font-weight-bold ml-auto">{{
              formatNumber(result.canceled.totalValue)
            }}</span>
          </div>
        </div>
      </StatisticCard>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions } from 'vuex';
import makeToast from 'Mixins/makeToast';
import { formatNumber } from '@/utils';
import UserTypes from '@/enums/UserTypes';
import StatusCard from 'Components/Cards/StatusCard.vue';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import StatisticCard from 'Components/Cards/StatisticCard.vue';
import { mapState } from 'vuex';

export default {
  name: 'OrderStatus',
  mixins: [makeToast],
  components: {
    StatisticCard
  },
  props: {
    shopkeepersIds: {
      type: Array,
      required: true,
    },
    startDate: {
      type: String,
      required: false,
    },
    endDate: {
      type: String,
      required: false,
    },
    origin: {
      type: String,
      require: false,
    }
  },
  data() {
    return {
      loading: false,
      result: {
        delivered: {
          total: 0,
          totalValue: 0,
        },
        pendingToDelivery: {
          total: 0,
          totalValue: 0,
        },
        pendingToPay: {
          total: 0,
          totalValue: 0,
        },
        sent: {
          total: 0,
          totalValue: 0,
        },
        canceled: {
          total: 0,
          totalValue: 0,
        },
      },
    };
  },
  watch: {
    shopkeepersIds: {
      deep: true,
      handler() {
        this.get();
      },
    },
    startDate: {
      deep: true,
      handler() {
        this.get();
      },
    },
    endDate: {
      deep: true,
      handler() {
        this.get();
      },
    },
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },
  mounted() {
    this.get();
  },
  methods: {
    formatNumber,
    ...mapActions('admin', ['getOrdersStatusSummary']),
    
    get() {
      this.loading = true;
      
      let lojista_id = '';
      let balconistaId = '';
      if(this.$route.meta.userType  == UserTypes.BALCONISTA){
        lojista_id = this.dadosUsuario.construp_user_id;
        balconistaId =  this.whatClerkPermission();
      }else{
        lojista_id = this.origin == "lojista" ? this.dadosUsuario.id : this.shopkeepersIds;
      }
 
      this.getOrdersStatusSummary({
        shopkeepersIds: lojista_id,
        clerkId: balconistaId,
        startDate: this.startDate,
        endDate: this.endDate,
      })
        .then((response) => {
          const { delivered, pendingToDelivery, pendingToPay, sent, canceled } =
            response.data.data || {};

          this.result.delivered = delivered || {};
          this.result.sent = sent || {};
          this.result.pendingToDelivery = pendingToDelivery || {};
          this.result.pendingToPay = pendingToPay || {};
          this.result.canceled = canceled || {};
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os pedidos',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    whatClerkPermission(){
      let permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
      let homePermission = permissionClerk.find(element => element.name == NamePermission.ESTATISTICA);

      if(this.$route.meta.userType == UserTypes.BALCONISTA && homePermission.type == TypePermission.BALCONISTA){
        return this.dadosUsuario.id;
      }
      return '';
    }
  },
};
</script>
<style scoped>
.cardPointer {
  cursor: pointer;
}

.cardStatus {
  margin: auto;
  @media (max-width: 700px) and (min-width: 375px) {
    display: flex;
     flex-wrap:wrap;
     flex-direction: column;
     margin-left: 0;
  }
}
</style>